import { DollarSign, ShoppingCart, CheckCircle2, Mail, MailWarning } from "lucide-react";

const Stat = ({ icon: Icon, label, value, testId }) => (
  <div className="rounded-2xl border border-white/10 bg-[#0b0d10] p-5" data-testid={testId}>
    <div className="flex items-center gap-2 text-zinc-400">
      <Icon className="h-4 w-4 text-[#2f7fff]" />
      <span className="text-xs uppercase tracking-widest">{label}</span>
    </div>
    <p className="mt-3 font-heading text-3xl text-white">{value}</p>
  </div>
);

export const AdminStats = ({ stats }) => (
  <div className="mt-8 grid grid-cols-2 gap-4 lg:grid-cols-5">
    <Stat icon={DollarSign} label="Revenue (paid)" value={`A$${stats.revenue}`} testId="stat-revenue" />
    <Stat icon={CheckCircle2} label="Paid orders" value={stats.paid_orders} testId="stat-paid-orders" />
    <Stat icon={ShoppingCart} label="Total checkouts" value={stats.total_orders} testId="stat-total-orders" />
    <Stat icon={Mail} label="PDFs emailed" value={stats.emails_delivered} testId="stat-emails-delivered" />
    <Stat icon={MailWarning} label="Recovery emails" value={stats.recovery_emails} testId="stat-recovery-emails" />
  </div>
);
